export default "__VITE_ASSET__BbtHXJ4A__"